<template>
<div :class="[{'row align-self-center pl-5 d-none d-md-block':!onModal}]">
    <b-col cols="12" :class = "{'d-flex picker-content':true, 'justify-content-between':paylineCount>1, 'justify-content-center':paylineCount===1}">
        <button v-if="paylineCount>1" @click="changePayline(-1)" :disabled="controlsDisabled" class="align-self-center"> 
            <fa-icon icon="caret-square-left"></fa-icon>
        </button>
        <div>
            <div class="label">{{ 'paylines_count' | lang }}</div>
            <div class="value">{{ payline }}</div>
        </div>
        <button v-if="paylineCount>1" @click="changePayline(+1)" :disabled="controlsDisabled" class="align-self-center">
            <fa-icon icon="caret-square-right"></fa-icon>
        </button>
    </b-col>
</div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
    props: ['controlsDisabled', 'onModal'],
    methods: {
        ...mapMutations(['updateCurrentPayline']),
        changePayline(action) {
            if(this.controlsDisabled) {
                return;
            }

            const paylinesKeys = Object.keys(Config.paylines_available);
            const currentKey = Config.paylines_available.indexOf(this.payline);
            const resultingKey = currentKey + action;

            if (resultingKey >= 0 && resultingKey < paylinesKeys.length) {
                this.updateCurrentPayline(Config.paylines_available[resultingKey]);
            }
        },
    },
    computed: {
        payline() {
            return this.$store.state.currentPayline;
        },
        paylineCount() {
            return Config.paylines_available.length;
        }
    }
}
</script>